import { useMutation } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';

export const useSetReminderMutation = (
  reminderType: string,
  reminderId: string,
  onSuccess: () => void,
  onError: () => void,
) => {
  const {
    data: mutationData,
    isError,
    isPending,
    mutate,
  } = useMutation({
    mutationFn: async (data: { delay: string }) => {
      const response = await request({
        url: `/notifications/reminders`,
        method: 'post',
        data: {
          reminder_notification: {
            reminder_type: reminderType,
            reminder_id: reminderId,
            delay: data.delay,
          },
        },
      });
      return response.data;
    },
    onError,
    onSuccess,
  });

  return {
    mutate,
    data: mutationData,
    isPending,
    isError,
  };
};
